import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var NextStepButton = function NextStepButton(_ref) {
  var disabled = _ref.disabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(NextButton, {
    variant: "primary",
    disabled: disabled,
    onClick: onClick,
    "data-test-id": "next-cta-button"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "oUPeOg",
    defaultMessage: "Next"
  }));
};
export var NeedMoreHelpButton = function NeedMoreHelpButton(_ref2) {
  var disabled = _ref2.disabled,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(NextButton, {
    variant: "secondary",
    disabled: disabled,
    onClick: onClick,
    "data-test-id": "need-more-help-cta-button"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4guDbU",
    defaultMessage: "I Need More Help"
  }));
};
export var SubmitButton = function SubmitButton(_ref3) {
  var disabled = _ref3.disabled,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(NextButton, {
    variant: "primary",
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "q1KDr6",
    defaultMessage: "Submit"
  }));
};
export var CloseModalButton = function CloseModalButton(_ref4) {
  var onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement(NextButton, {
    variant: "primary",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Hco1MS",
    defaultMessage: "Close"
  }));
};
var NextButton = styled(Button).withConfig({
  displayName: "NavigationButtons__NextButton"
})(["width:100%;height:50px;"]);